module.exports = __webpack_public_path__ + "static/media/crowd.10810342.jpg";